import React, { useEffect, useState } from "react";
import CustomerItem from "../Detail/CustomerItem";
import Icon from "../Detail/Icons";
import { useDetectClickOutside } from "react-detect-click-outside";
import { useTranslation } from "../../context/TranslationContext";

const Customer = ({ customer, setCustomer, maxCapacity = 0 }) => {
  const {
    customer: customerText,
    adult,
    child,
    childAge,
    infant,
    infantAge,
  } = useTranslation();
  const [yetiskin, setYetiskin] = useState(customer[0].yetiskin);
  const [cocuk, setCocuk] = useState(customer[0].cocuk);
  const [yetiskinMax, setYetiskinMax] = useState(maxCapacity);
  const [cocukMax, setCocukMax] = useState(maxCapacity);
  const [bebek, setBebek] = useState(customer[0].bebek);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (maxCapacity > 0) {
      if (parseInt(cocuk + yetiskin) <= parseInt(maxCapacity)) {
        setCustomer([
          {
            cocuk,
            yetiskin,
            bebek,
          },
        ]);
      }
      setYetiskinMax(maxCapacity - cocuk);
      setCocukMax(maxCapacity - yetiskin);
    } else {
      setCustomer([
        {
          cocuk,
          yetiskin,
          bebek,
        },
      ]);
    }
  }, [yetiskin, cocuk, bebek]);

  function ToggleShow() {
    setIsShow(!isShow);
  }
  function CloseToggle() {
    setIsShow(false);
  }
  const ref = useDetectClickOutside({ onTriggered: CloseToggle });

  return (
    <div ref={ref}>
      <div className="bg-white flex flex-col">
        <div
          className="flex items-center pt-4 pb-1 ml:py-5 pl-8 pr-7 cursor-pointer"
          onClick={(e) => {
            ToggleShow();
          }}
        >
          <div className="flex justify-between flex-1">
            <div className="flex flex-wrap">
              <span className="font-bold text-brand-gray-2 text-13 w-full">
                {customerText}
              </span>
              <span className="font-bold text-xl mr-8">
                {yetiskin}
                <span className="text-xs -top-0.5 relative inline-block ml-1.5">
                  {adult}
                </span>
              </span>
              <span className="font-bold text-xl">
                {cocuk}
                <span className="text-xs -top-0.5 relative inline-block ml-1.5">
                  {child}
                </span>
              </span>
            </div>
          </div>
          <div className="mt-5">
            <Icon name={"ArrowDown"}></Icon>
          </div>
        </div>
        {isShow && (
          <div className="flex flex-col py-5 pl-8 pr-7 ">
            <CustomerItem
              onchange={(e) => {
                setYetiskin(e);
              }}
              title={adult}
              defaultValue={yetiskin}
              min={1}
              max={yetiskinMax}
            ></CustomerItem>
            <CustomerItem
              onchange={(e) => {
                setCocuk(e);
              }}
              title={child}
              defaultValue={cocuk}
              subTitle={childAge}
              max={cocukMax}
            ></CustomerItem>
            <CustomerItem
              onchange={(e) => {
                setBebek(e);
              }}
              title={infant}
              subTitle={infantAge}
              defaultValue={bebek}
            ></CustomerItem>
          </div>
        )}
      </div>
    </div>
  );
};

export default Customer;
